
import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import dayjs from "dayjs";
import { DatePicker, Card, Spin, Divider } from "antd";
import {
  CalendarOutlined,
} from "@ant-design/icons";
import Apiauth from "../../api/Apiauth";
import { showToast, Maintanance, hasPermission } from "../../utils";

import PageHeader from "../../components/PageHeader";
import AddContact from "../../components/AddContact";
import { TableOverview } from "./tabel-chart";
import { onPressAddContact } from "../../actions";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import AppContext from "../../components/AppContext";
import { handleCheckError } from "../../utils/fetchData";

import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
import ReportCustomersSummary from "./reportCustomersSummary";
import i18next from "i18next";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

class Index extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showContaint: "Table",
      message: "",
      startDate: null,
      endDate: null,
      reportData: [],
      isMobile: window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  fetchReportData = async () => {
    const { startDate, endDate } = this.state;
    const { merchantId } = this.context;
    this.setState({ loading: true });

    // ใช้ dayjs() เป็น default ถ้ายังไม่ได้เลือกวันที่
    const start = startDate ? dayjs(startDate).format(dateFormat) : dayjs().format(dateFormat);
    const end = endDate ? dayjs(endDate).format(dateFormat) : dayjs().format(dateFormat);

    const raw = JSON.stringify({
      startDate: start,
      endDate: end,
      type: "date",
      merchantId: merchantId,
    });

    try {
      const response = await Apiauth.gerReportDaily(raw);
      if (response.data.success) {
        this.setState({
          reportData: response.data.data || [],
          loading: false,
          message: response.data.message,
        });
      } else {
        showToast("error", response.data.message || "Failed to fetch report data.");
        this.setState({ loading: false, reportData: [] });
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      handleCheckError(error, "");
      this.setState({ loading: false });
    }
  };

  handleDateRangeChange = (dates) => {
    if (!dates) {
      this.setState({ startDate: null, endDate: null, reportData: [] });
      return;
    }

    this.setState(
      {
        startDate: dates[0],
        endDate: dates[1],
      },
      () => this.fetchReportData()
    );
  };

  onOk = async (dates) => { };

  handleDateRangeOkMobile = async (dates) => {
    const newStartDate = dates ? dates[0] : null;
    const newEndDate = dates ? dates[1] : null;

    if (!newStartDate && !newEndDate) {
      this.setState({ startDate: null, endDate: null, reportData: [] });
      return;
    }
    await this.handleDateRangeOk(dates);
  };
  handleDateRangeOk = async (dates) => {
    const newStartDate = dates ? dates[0] : null;
    const newEndDate = dates ? dates[1] : null;

    if (!newStartDate && !newEndDate) {
      return;
    }
    this.setState(
      {
        startDate: newStartDate,
        endDate: newEndDate,
      },
      async () => await this.fetchReportData(),
    );
  };

  onChangSegmented = (value) => {
    // การใช้ getElementById ใน React ไม่ค่อยแนะนำนัก แต่ถ้าจำเป็นต้องทำเพื่อเข้าถึง Class เดิม ให้ทำดังนี้:
    const documentContactCard = document.getElementById("ContactCard");
    const documentTableChart = document.getElementById("TableChart");

    if (value === "ContactCard") {
      if (documentContactCard) documentContactCard.className = "in row clearfix mt-5";
      if (documentTableChart) documentTableChart.className = "d-none";
    } else {
      if (documentContactCard) documentContactCard.className = "d-none row clearfix mt-5";
      if (documentTableChart) documentTableChart.className = "out";
    }
    this.setState({ showContaint: value });
  };

  getAntdLocale = () => {
    const { i18n } = this.props;
    return (i18n.language === "th" || i18n.language === "lao") ? localeTH : localeEN;
  };

  disabledDate = (current) => {
    if (!current) return false;

    // 1. ห้ามเลือกวันที่ในอนาคต (หลังจากวันนี้)
    const isAfterToday = current.isAfter(dayjs().endOf('day'));

    // 2. ห้ามเลือกวันที่เก่ากว่า 60 วันที่แล้ว
    const sixtyDaysAgo = dayjs().subtract(60, 'days').startOf('day');
    const isBefore60Days = current.isBefore(sixtyDaysAgo);

    return isAfterToday || isBefore60Days;
  };
  render() {
    const { isContactModal, t, i18n } = this.props;
    const { reportData, loading, message, startDate, endDate } = this.state;
    const { maintanance, resProfileAdmin, resReportCustomersSummary, isLoadReportCustomers } = this.context;
    const currentLanguage = i18next.language;

    let currentLng = currentLanguage === "lao" ? "lo" : currentLanguage;

    let { permissions, admin_type } = resProfileAdmin || {};

    let showSummaryReportCustomers = ["programer"].includes(admin_type);

    const antdLocale = this.getAntdLocale();
    dayjs.locale(i18n.language === "lao" ? "lo" : i18n.language);

    const userPermissions = Array.isArray(permissions) ? permissions : [];
    const accessible_download = hasPermission(userPermissions, "download_report");
    const accessible_view_past = hasPermission(userPermissions, "view_past_report");

    let suffixIconUI = (<CalendarOutlined style={{ fontSize: "15px", color: "#5A5A5A" }} />)
    let prefixUI = (<><CalendarOutlined style={{ marginRight: 5 }} /> </>)
    let footerUI = (<span className="d-block text-danger fs-12 fs-sm-10">* {t("transaction_history_note")}</span>)
    // UI ส่วน RangePicker สำหรับ Reuse
    const RangePickerComponent = (
      <RangePicker
        disabled={!maintanance}
        locale={antdLocale}
        disabledDate={this.disabledDate}
        presets={!this.state.isMobile ? [
          { label: t("7 วันที่ผ่านมา"), value: [dayjs().add(-7, "d"), dayjs()] },
          { label: t("14 วันที่ผ่านมา"), value: [dayjs().add(-14, "d"), dayjs()] },
          { label: t("30 วันที่ผ่านมา"), value: [dayjs().add(-30, "d"), dayjs()] },
          { label: t("60 วันที่ผ่านมา"), value: [dayjs().add(-60, "d"), dayjs()] },
        ] : []}
        prefix={prefixUI}
        size="large"
        suffixIcon={suffixIconUI}
        format={dateFormat}
        placeholder={[t("StartDate"), t("EndDate")]}
        onChange={this.handleDateRangeChange}
        value={startDate && endDate ? [startDate, endDate] : null}
        renderExtraFooter={() => footerUI}
      />
    );

    const RangePickerMobileComponent = (<RangePicker
      disabledDate={this.disabledDate}
      disabled={!maintanance}
      locale={antdLocale}
      prefix={prefixUI}
      size="medium"
      suffixIcon={suffixIconUI}
      showTime={{ format: "HH:mm" }}
      format={dateFormat}
      placeholder={[t("StartDate"), t("EndDate")]}
      style={{ marginRight: 8 }}
      onChange={this.handleDateRangeOkMobile}
      renderExtraFooter={() => footerUI}
      onOk={this.onOk}
    />);

    return (
      <div style={{ flex: 1 }}>
        <div style={{ opacity: isContactModal ? 0.3 : 1 }}>
          <div className="container-fluid">
            <PageHeader
              HeaderText={t("Overview")}
              Breadcrumb={[
                {
                  name: removeSlashesFromPath(window.location.pathname),
                  navigate: window.location.pathname,
                },
              ]}
            />

            <Spin spinning={loading} tip={t("Loading...")}>
              <Card
                className="card-report"
                style={{ background: "none", boxShadow: "none", border: "none" }}
              >
                <div id="TableChart">
                  {!maintanance ? (
                    <Maintanance />
                  ) : (
                    <>
                      {/* Report Customers Summary เฉพาะ Programer เท่านั้น */}
                      {showSummaryReportCustomers && (<div className="p-3"><ReportCustomersSummary isLoadReportCustomers={isLoadReportCustomers} locale={currentLng} data={resReportCustomersSummary} t={t} /></div>)}

                      <Divider orientation='left'>{t("Overview")}</Divider>
                      <TableOverview
                        data={reportData}
                        message={message}
                        loading={loading}
                        startDate={startDate}
                        endDate={endDate}
                        t={t}
                        accessible_download={accessible_download}
                        RangePickerComponent={RangePickerComponent}
                        RangePickerMobileComponent={RangePickerMobileComponent}
                        accessible_view_past={accessible_view_past}
                      />
                    <Divider />

                    </>
                  )}
                </div>
              </Card>
            </Spin>
          </div>
        </div>
        <AddContact />
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isContactModal: mailInboxReducer.isContactModal,
});

export default connect(mapStateToProps, { onPressAddContact })(
  withTranslation()(Index),
);